import { observer } from "mobx-react-lite";
import React from "react";
import { useTranslation } from "react-i18next";
import { InteractionTriggerIconType } from "../../../../shared/game/InteractionTriggerIconType";
import { InteractionTriggerSelectionDetail } from "./components/InteractionElementSelectionDetail";
import { Dropdown } from "../../editor/Dropdown";
import { ElementGroup, ElementLabel } from "./components/BaseElements";
export const InteractionTriggerActionDetails = observer(({
  interactionTrigger,
  setInteractionTrigger,
  iconType,
  setIconType
}) => {
  const {
    t
  } = useTranslation();
  return /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement(InteractionTriggerSelectionDetail, {
    name: null,
    selectedInteractionTrigger: interactionTrigger,
    interactionTriggerSetter: setInteractionTrigger
  })), /*#__PURE__*/React.createElement(ElementGroup, null, /*#__PURE__*/React.createElement(ElementLabel, null, t("action_editor.interaction_type")), /*#__PURE__*/React.createElement(Dropdown, {
    value: iconType,
    onChange: ({
      target
    }) => setIconType(target.value)
  }, Object.values(InteractionTriggerIconType).map(type => /*#__PURE__*/React.createElement("option", {
    key: type,
    value: type
  }, t("action_editor.interaction_type_" + type))))));
});